// extracted by mini-css-extract-plugin
module.exports = {"highlight":"Syqvh","BG":"_3PE4q","frame":"_2Bq8V","diamond":"_1bb5D","headingAboutThe":"_34aYj","noMoreLongForms":"tW5Ok"};